import { Button, Modal, Select } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { startNoProcedente } from "../../../../context/actions/detalleActions";
import { opcionesNoProcedente } from "../../../../constants/cons";

export const FormaNoProcedente = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const { asistenciaID } = useParams();
  const [motivoNoProcedente, setMotivoNoProcedente] = React.useState("");
  const submit = () => {
    dispatch(startNoProcedente({ motivoNoProcedente, asistenciaID }));
    setOpen(false);
  };

  return (
    <div>
      <Button onClick={() => setOpen(true)} size="small" type="dashed" danger>
        Marcar no procedente
      </Button>
      <Modal
        onCancel={() => setOpen(false)}
        width={800}
        title="Servicio no procede"
        handleCancel={() => setOpen(false)}
        footer={[
          <Button onClick={() => setOpen(false)} danger size="small">
            cerrar
          </Button>,
        ]}
        open={open}
      >
        <div style={{ paddingTop: 20, paddingBottom: 30 }}>
          <Select
            onChange={(val) => setMotivoNoProcedente(val)}
            style={{ width: "100%" }}
            options={opcionesNoProcedente}
          />
          <Button
            onClick={submit}
            disabled={!motivoNoProcedente}
            type="primary"
            style={{ width: "100%", marginTop: 20 }}
          >
            Establecer servicio: No Procede
          </Button>
        </div>
      </Modal>
    </div>
  );
};
